import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const SectionBlock = styled.div`
  margin-bottom: ${space[8]};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[3]};
  flex: 1;
  justify-content: space-between;

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex: initial;
    justify-content: flex-start;
  }
`;

export const SectionTitle = styled.span`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.normal};
  color: ${colors.fontPrimary};
  line-height: 1.3;
`;


export const BannerCard = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;

  @media (min-width: ${layout.desktopBreakpoint}) {
    aspect-ratio: 21 / 9;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const BannerPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background: ${colors.lighterGrey};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.grey};
`;

export const BannerOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, transparent 60%);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: ${space[5]};
`;

export const BannerTitle = styled.span`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.medium};
  color: ${colors.white};
  margin-bottom: ${space[3]};
`;

